import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="flash"
export default class extends Controller {
  static identifier = "flash"

  connect() {
    // Auto-dismiss after 5 seconds
    this.dismissTimer = setTimeout(() => this.fadeAndRemove(), 5000)
  }

  disconnect() {
    if (this.dismissTimer) {
      clearTimeout(this.dismissTimer)
      this.dismissTimer = null
    }
  }

  dismissAll(event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }

    // Minimal behavior: clear all notification stacks immediately.
    // (We intentionally clear both stacks: bottom-right flash + top-right JS toasts.)
    const containers = [
      document.getElementById("flash-messages"),
      document.getElementById("app-toast-container")
    ].filter(Boolean)

    containers.forEach((container) => container.replaceChildren())
  }

  fadeAndRemove() {
    if (!this.element || !this.element.isConnected) return

    this.element.classList.add("fade-out")
    setTimeout(() => this.element?.remove(), 500)
  }
}
